import { hexToNumber, isHex } from "../../encoding/hex.js";
/**
 * @internal
 */
export function parseTypedData(typedData) {
    const domain = typedData.domain;
    if (domain?.chainId !== undefined && isHex(domain.chainId)) {
        typedData.domain = {
            ...typedData.domain,
            chainId: hexToNumber(typedData.domain.chainId),
        };
    }
    return typedData;
}
//# sourceMappingURL=parseTypedData.js.map